module.exports = "<div>\n    <a class=\"btn btn--primary\"  (click)=\"register()\">{{btnText}}</a>\n</div>"